export default "__VITE_ASSET__CgU$Pfqk__"